import { useContext } from 'react';
import { LocaleContext } from '../context/LocaleContext';

import Education from './Education';
import JobExperience from './JobExperience';
import Project from './Project';

import TypeIt from "typeit-react";

import educations from '../data/education.json';
import jobExperiences from '../data/jobExperiences.json';
import projects from '../data/projects.json';

export default function Section(){
    const { language } = useContext(LocaleContext)

    return (
        <section className="col-12 col-md-8 p-4">
                
            {/* CARD NOME E COGNOME */}
            <nav
                className="row align-items-center d-none d-md-flex mx-0 mb-5"
                data-aos="fade-left"
            >
                <div className="col text-center">
                    <h1>PIETRO LUBRANO</h1>
                    <h2 className="p lead">
                        <strong>
                            <TypeIt
                                getBeforeInit={(instance) => {
                                    instance
                                        .pause(1000)
                                        .type("JUNIOR FULL STACK DEVELOPER")
                                    // Remember to return it!
                                    return instance;
                                }}
                            />
                        </strong>
                    </h2>
                    {/* <h2 className="p lead"><strong>JUNIOR WEB DEVELOPER</strong></h2> */}
                </div>
            </nav>
            
            {/* ISTRUZIONE */}

            <div
                className="row align-items-center aos-istruzione"
                data-aos="fade-left"
                data-aos-delay="100"
            >
                
                <div className="col-1 me-3">
                    <i className="fas fa-graduation-cap fa-2x lightblue-icon"></i>
                </div>
                <div className="col">
                    <h4 className="m-0">
                        {
                            language === 'ita' ?
                                'ISTRUZIONE'
                            :
                                'EDUCATION'
                        }
                    </h4>
                </div>
                
            </div>
            
            <hr className="mb-md-4" />
            
            {
                educations[language].map( (education, index) => 
                    <Education
                        key={education.school}
                        education={education}
                        index={index}
                    />
                )
            }
            
            {/* ESPERIENZA LAVORATIVE */}
            
            <div
                className="row align-items-center aos-lavorative"
                data-aos="fade-left"
            >
                
                <div className="col-1 me-3">
                    <i className="fas fa-briefcase fa-2x lightblue-icon"></i>
                </div>
                <div className="col">
                    <h4 className="m-0">
                        {
                            language === 'ita' ?
                                'ESPERIENZE LAVORATIVE'
                            :
                                'JOB EXPERIENCES'
                        }
                    </h4>
                </div>

                <hr className="mb-4" />

            </div>
            
            
            {
                jobExperiences[language].map( (jobExperience, index) => 
                    <JobExperience 
                        key={jobExperience.companyName}
                        jobExperience={jobExperience}
                        index={index}
                    />
                )
            }
            
            {/* PROGETTI REALIZZATI */}
            
            <div
                className="row align-items-center aos-progetti"
                data-aos="fade-left"
            >
                <div className="col-1 me-3">
                    <i className="fas fa-flask fa-2x lightblue-icon"></i>
                </div>
                <div className="col">
                    <h4 className="m-0">
                        {
                            language === 'ita' ?
                                'PROGETTI REALIZZATI'
                            :
                                'PROJECTS'
                        }
                    </h4>
                </div>
            </div>

            <hr className="mb-4" />

            {
                projects[language].map( (project, index) => 
                    <Project key={project.name} project={project} index={index}/>
                )
            }
            
        </section>
    )
}